const FormSelect = ({ label, children, ...props }) => (
  <div>
    <label className="block text-lg font-medium text-gray-700 mb-1">{label}</label>
    <select {...props} className="w-full px-3 py-2 border rounded">
      {children}
    </select>
  </div>
);

export default FormSelect;